export var Sentiment;
(function (Sentiment) {
    Sentiment["Frustration"] = "hasFrustration";
    Sentiment["Gratitude"] = "hasGratitude";
    Sentiment["Praise"] = "hasPraise";
})(Sentiment || (Sentiment = {}));
//# sourceMappingURL=sentiment.js.map